import { useRouter } from 'next/router'

export const useBasePath = () => {
  const router = useRouter()

  const { spaceId } = router.query

  return `/${spaceId}`
}
